/* AP Sale Countdown — ticks every [data-ap-countdown] element.
   The attribute holds an ISO-8601 instant (with timezone offset) for the sale
   end. Displays d/h/m/s remaining; hides itself once expired. Loaded once. */
(function () {
  if (window.__apSaleCd) return;
  window.__apSaleCd = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function format(ms) {
    if (ms <= 0) return null;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
    if (h > 0) return pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(m) + ':' + pad(s);
  }

  function tick() {
    var els = document.querySelectorAll('[data-ap-countdown]');
    if (!els.length) return;
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = new Date(el.getAttribute('data-ap-countdown')).getTime();
      var out = format(end - now);
      if (out === null) {
        el.classList.add('is-ended');
        el.style.display = 'none';
      } else {
        var t = el.querySelector('.ap-sale-cd__time');
        if (t) t.textContent = out;
      }
    }
  }

  function start() { tick(); setInterval(tick, 1000); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
